var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"form-group\" :class=\"{ required: !!required }\">\n    <label :for=\"`input-group${_uid}`\" class=\"control-label\">\n      {{ label }}\n      <slot></slot>\n    </label>\n\n    <!--Text input-->\n    <input :id=\"`input-group${_uid}`\"\n           v-if=\"type === 'text'\"\n           type=\"text\"\n           :maxlength=\"maxlength\"\n           :required=\"!!required\"\n           :placeholder=\"placeholder\"\n           v-model=\"computedModel\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"1\"/>\n\n    <!--Email input-->\n    <input :id=\"`input-group${_uid}`\"\n           v-else-if=\"type === 'email'\"\n           type=\"email\"\n           :maxlength=\"maxlength\"\n           :required=\"!!required\"\n           :placeholder=\"placeholder\"\n           v-model=\"computedModel\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"2\"/>\n\n    <!--Password input-->\n    <input :id=\"`input-group${_uid}`\"\n           v-else-if=\"type === 'password'\"\n           type=\"password\"\n           :maxlength=\"maxlength\"\n           :required=\"!!required\"\n           :placeholder=\"placeholder\"\n           v-model=\"computedModel\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"3\"/>\n\n    <!--Number input-->\n    <input :id=\"`input-group${_uid}`\"\n           v-else-if=\"type === 'number'\"\n           type=\"number\"\n           :required=\"!!required\"\n           :step=\"`${step}`\"\n           :min=\"`${min}`\"\n           :max=\"`${max}`\"\n           :placeholder=\"placeholder\"\n           v-model.number=\"computedModel\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"4\"/>\n\n    <!--Masked input-->\n    <the-mask :id=\"`input-group${_uid}`\"\n           v-else-if=\"type === 'mask'\"\n           type=\"text\"\n           :required.native=\"!!required\"\n           :placeholder=\"placeholder\"\n           :mask=\"presetMasked || mask\"\n           :masked=\"masked\"\n           :tokens=\"tokens\"\n           v-model=\"computedModel\"\n           :disabled.native=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus.native=\"focusEvent\"\n           @blur.native=\"blurEvent\"\n           :key=\"5\"/>\n\n    <!--Currency input-->\n    <money :id=\"`input-group${_uid}`\"\n           v-else-if=\"type === 'money'\"\n           v-model=\"computedModel\"\n           :maxlength=\"maxlength\"\n           :required=\"!!required\"\n           :placeholder=\"placeholder\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus.native=\"focusEvent\"\n           @blur.native=\"blurEvent\"\n           :key=\"6\"/>\n\n    <!--Special input for date, datetime, cpf, cnpj, rg, phone, cep-->\n    <!--Note: In order to avoid glitch on android devices, the type is set to \"tel\"-->\n    <input :id=\"`input-group${_uid}`\"\n           v-else\n           type=\"tel\"\n           :required=\"!!required\"\n           :placeholder=\"placeholder\"\n           v-mask=\"presetMasked\"\n           v-model=\"computedModel\"\n           :disabled=\"disabled\"\n           class=\"form-control\"\n           :class=\"{valid: valid === true, invalid: valid === false}\"\n           @focus=\"focusEvent\"\n           @blur=\"blurEvent\"\n           :key=\"7\"/>\n\n  </div>\n";
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { $ } from '../../simpli';
import * as Helper from '../../helpers';
var InputText = /** @class */ (function (_super) {
    __extends(InputText, _super);
    function InputText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.valid = null;
        _this.date = null;
        _this.datetime = null;
        return _this;
    }
    Object.defineProperty(InputText.prototype, "presetMasked", {
        get: function () {
            var preset = this.type === 'mask' ? this.preset : this.type;
            if (preset === 'date')
                return $.t('dateFormat.datemask');
            else if (preset === 'datetime')
                return $.t('dateFormat.datetimemask');
            else if (preset === 'cpf')
                return $.t('format.cpf');
            else if (preset === 'cnpj')
                return $.t('format.cnpj');
            else if (preset === 'cpfCnpj')
                return [$.t('format.cpf'), $.t('format.cnpj')];
            else if (preset === 'rg')
                return $.t('format.rg');
            else if (preset === 'phone')
                return [$.t('format.phone'), $.t('format.phoneAlt')];
            else if (preset === 'cep')
                return $.t('format.cep');
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "reservedMasks", {
        get: function () {
            return ['cpf', 'cnpj', 'cpfCnpj', 'rg', 'phone', 'cep'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "computedModel", {
        get: function () {
            var _a = this, type = _a.type, reservedMasks = _a.reservedMasks;
            if (type === 'date') {
                return this.inputDate;
            }
            else if (type === 'datetime') {
                return this.inputDatetime;
            }
            else if (reservedMasks.includes(type)) {
                return this.inputMasked;
            }
            else if (type === 'money') {
                return this.input || 0;
            }
            else {
                return this.input;
            }
        },
        set: function (input) {
            var _a = this, type = _a.type, reservedMasks = _a.reservedMasks;
            if (type === 'date') {
                this.inputDate = input;
            }
            else if (type === 'datetime') {
                this.inputDatetime = input;
            }
            else if (reservedMasks.includes(type)) {
                this.inputMasked = input;
            }
            else {
                this.input = input;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "input", {
        get: function () {
            return this.value;
        },
        set: function (val) {
            if (this.required) {
                this.$emit('input', val || '');
            }
            else {
                this.$emit('input', val || null);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "inputMasked", {
        get: function () {
            var type = this.type;
            var input = this.input;
            if (type === 'cpf')
                return Helper.cpf(input);
            else if (type === 'cnpj')
                return Helper.cnpj(input);
            else if (type === 'cpfCnpj')
                return Helper.cpfOrCnpj(input);
            else if (type === 'rg')
                return Helper.rg(input);
            else if (type === 'phone')
                return Helper.phone(input);
            else if (type === 'cep')
                return Helper.cep(input);
            return input;
        },
        set: function (input) {
            this.input = $.filter.removeDelimiters(Helper.toString(input));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "inputDate", {
        get: function () {
            return this.date;
        },
        set: function (input) {
            var value = Helper.toString(input);
            var date = moment(value, $.t('dateFormat.date'));
            this.date = value;
            if (value.length < 10) {
                this.input = null;
                this.valid = value.length === 0 ? null : false;
            }
            else if (date.isValid()) {
                this.input = date.format();
                this.valid = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputText.prototype, "inputDatetime", {
        get: function () {
            return this.datetime;
        },
        set: function (input) {
            var value = Helper.toString(input);
            var date = moment(value, $.t('dateFormat.datetime'));
            this.datetime = value;
            if (value.length !== 10 && value.length !== 11 && value.length < 16) {
                this.input = null;
                this.valid = value.length === 0 ? null : false;
            }
            else if (date.isValid()) {
                this.input = date.format();
                this.valid = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    InputText.prototype.created = function () {
        var _a = this, value = _a.value, type = _a.type;
        if (value === null) {
            this.input = value;
        }
        if (type === 'date' || type === 'datetime') {
            var date = value ? moment(value) : null;
            if (date && date.isValid()) {
                this.date = date.format($.t('dateFormat.date'));
                this.datetime = date.format($.t('dateFormat.datetime'));
            }
        }
    };
    InputText.prototype.mounted = function () {
        var el = this.$el.getElementsByTagName('input')[0];
        if (el && this.autofocus)
            el.focus();
    };
    InputText.prototype.focusEvent = function () {
        var el = this.$el.getElementsByTagName('input')[0];
        if (el && this.selectall)
            el.select();
        this.$emit('focus');
    };
    InputText.prototype.blurEvent = function () {
        this.$emit('blur');
    };
    __decorate([
        Prop({ type: [String, Number], default: null }),
        __metadata("design:type", Object)
    ], InputText.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, required: true, default: 'text' }),
        __metadata("design:type", String)
    ], InputText.prototype, "type", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "required", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "maxlength", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "label", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "step", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "min", void 0);
    __decorate([
        Prop({ type: [String, Number] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "max", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "placeholder", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "autofocus", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "selectall", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], InputText.prototype, "preset", void 0);
    __decorate([
        Prop({ type: [String, Array] }),
        __metadata("design:type", Object)
    ], InputText.prototype, "mask", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], InputText.prototype, "masked", void 0);
    __decorate([
        Prop({ type: Object }),
        __metadata("design:type", Object)
    ], InputText.prototype, "tokens", void 0);
    InputText = __decorate([
        Component({ template: template })
    ], InputText);
    return InputText;
}(Vue));
export { InputText };
//# sourceMappingURL=InputText.js.map